import { render, staticRenderFns } from "./RepairType.vue?vue&type=template&id=f1934dbe"
import script from "./RepairType.vue?vue&type=script&lang=js"
export * from "./RepairType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports